import { Checkbox, Select, Tag } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { ANTD_GRAY_V2 } from '../../../constants';
import { getStructuredPropertyValue } from '../../../utils';
import ValueDescription from '../../../entityForm/prompts/StructuredPropertyPrompt/ValueDescription';
// import { AllowedValue } from '../../../../../../types.generated';
import DropdownLabel from './DropdownLabel';

const StyledCheckbox = styled(Checkbox)`
    display: flex;
    margin: 0 0 4px 0;
    .ant-checkbox-inner {
        border-color: ${ANTD_GRAY_V2[8]};
    }
    &&& {
        margin-left: 0;
    }

    &&.ant-checkbox-wrapper {
        .ant-checkbox + span {
            overflow: hidden;
            white-space: nowrap;
            display: inline-block;
            text-overflow: ellipsis;
        }
    }
`;

const StyledTag = styled(Tag)`
    span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block !important;
    }
`;

const DROPDOWN_STYLE = { minWidth: 320, textAlign: 'left' };

interface Props {
    selectedValues: any[];
    allowedValues: any[];
    toggleSelectedValue: (value: string | number) => void;
    updateSelectedValues: (values: string[] | number[]) => void;
}

export default function MultiSelectInput({
    toggleSelectedValue,
    updateSelectedValues,
    allowedValues,
    selectedValues,
}: Props) {
    const shouldShowSelectDropdown = allowedValues.length > 5;

    return shouldShowSelectDropdown ? (
        <Select
            size="large"
            mode="multiple"
            placeholder="Select"
            value={selectedValues}
            style={DROPDOWN_STYLE as any}
            options={allowedValues.map((allowedValue) => ({
                value: getStructuredPropertyValue(allowedValue.value),
                label: (
                    <DropdownLabel
                        value={getStructuredPropertyValue(allowedValue.value)}
                        description={allowedValue.description}
                    />
                ),
            }))}
            tagRender={(tagProps: any) => {
                return (
                    <StyledTag closable={tagProps.closable} onClose={tagProps.onClose}>
                        <span>{tagProps.value}</span>
                    </StyledTag>
                );
            }}
            onChange={(value) => updateSelectedValues(value)}
        />
    ) : (
        <div>
            {allowedValues.map((allowedValue) => (
                <StyledCheckbox
                    key={getStructuredPropertyValue(allowedValue.value)}
                    value={getStructuredPropertyValue(allowedValue.value)}
                    onChange={(e) => toggleSelectedValue(e.target.value)}
                    checked={selectedValues.includes(getStructuredPropertyValue(allowedValue.value))}
                >
                    {getStructuredPropertyValue(allowedValue.value)}
                    {allowedValue.description && <ValueDescription description={allowedValue.description} />}
                </StyledCheckbox>
            ))}
        </div>
    );
}
